import api from '../api';
import { IChangePassword } from '../models/user';
import JSCookies from 'js-cookie';
const baseUrl = 'pwa/user';


export class UserService {
  public async changePassword(model: IChangePassword) {
    const { data: token } = await api.put(`${baseUrl}/change-password`, model);
    JSCookies.set('token', token.accessToken, { expires: 480 });
    api.defaults.headers.Authorization = `Bearer ${token.accessToken}`;
  }
}

const userService = new UserService();
export default userService;
